import { FC } from "react";
import { Flex, Text } from "@smile2impress/components/relaunch";

import { AdvantageProps } from "./Advantage.types";

export const Advantage: FC<AdvantageProps> = ({ title, subtitle }) => (
    <Flex direction="column">
        <Text textStyle="H2" color={["text.baseInverse"]}>
            {title}
        </Text>
        {!!subtitle && (
            <Text textStyle="H3" color={["text.baseInverse"]}>
                {subtitle}
            </Text>
        )}
    </Flex>
);
